// removed by extract-text-webpack-plugin
module.exports = {"appDetailListContainer":"_2E3ZPRQ6N8CLn33DEhj_EX","appDetailList":"_2Mf5FKGYQXd477zN52G3T4","listTop":"_1rUnB6xaZE-iONCsPWDPnS","msgContainer":"_10OI1y-ASOuZmuKc285PWv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DeviceInfo/AppDetailList.less
// module id = 563
// module chunks = 0